import React from 'react'

import { AlertsContext } from '../common/Alerts/Alerts'

const useAlerts = () => React.useContext(AlertsContext)

export default useAlerts
